export default class BlockDealsGroup {

    constructor(container, apiEndpoint, options) {
        const defaultOptions = {
            blocksContainer: '.blocks-container',
            carouselContainer: '.carousel-container .swiper-wrapper',
            modalsContainer: '.modals-container',
            swiper: '.deals-list-swiper',
            modal: '.deal-modal',
            infoIcon: '.icon-info',
            modalClose: '.icon-modal-close',
            title: '.title-container .title'
        };

        this.options = Object.assign({}, defaultOptions, options);

        this.apiEndpoint = apiEndpoint;

        this.container = document.querySelector(container);
        this.blocksContainer = this.container.querySelector(this.options.blocksContainer);
        this.carouselContainer = this.container.querySelector(this.options.carouselContainer);
        this.modalsContainer = this.container.querySelector(this.options.modalsContainer);

        this.swiperElem = this.container.querySelector(this.options.swiper);
        this.modals = this.container.querySelectorAll(this.options.modal);
        this.modalCloseIcons = this.container.querySelectorAll(this.options.modalClose);
        this.infoIcons = this.container.querySelectorAll(this.options.infoIcon);
        this.swiper = null; 

        this.title = this.container.querySelector(this.options.title);
        
        this.geoData = localStorage.getItem('geo');

        this.init();
    }

    init(){

        fetch(this.apiEndpoint)
            .then(response => response.json())
            .then(dealsGroup =>  {
                                
                this.displayDealItems(dealsGroup);

                this.container.classList.remove('loading');
            
            });

    }

    displayDealItems(dealsGroup){
    
        const dealsToRender = this.getDealsToRender(dealsGroup);

        this.renderBlockItems(dealsToRender);

        if(this.carouselContainer !== null){            
            this.renderCarouselItems(dealsToRender);        
            this.initSwiper();
        }

        this.renderModals(dealsToRender);
        this.setModalEvents();

        
    }

    getDealsToRender(dealsGroup){

        const now = this.getCurrentAustralianTime();
        const geo = this.geoData !== null ? JSON.parse(this.geoData) : null;

        const filteredItems = dealsGroup.conditionalDeals.filter(item=> {

            if(new Date(item.startDate) > now)
                return false;

            if(new Date(item.endDate) < now)
                return false;

            if(geo !== null)
            {
                if(!item.countryCodes.some(code => code == geo.countryCode))                
                    return false;

                //TODO: No region data from https://where-am-i.teeg.cloud/?geo=true
            }
            
            return true;

        });

        if (filteredItems.length > 0)
            return filteredItems[0].deals;

        return dealsGroup.defaultDeals;
    }

    getCurrentAustralianTime() {

        const TIMEZONE = 'Australia/Sydney';

        const currentDateTime = new Date();

        const localeString = currentDateTime.toLocaleString("en-US", {timeZone: TIMEZONE});

        return new Date(localeString);   
    }

    renderModals(items){

        let html = '';

        items.filter(item=> item.modal !== null)
            .forEach(item => {

                const modal = item.modal;

                html += ` <div class="deal-modal" data-modal-id="modal-${item.id}">
                                <div class="deal-modal-details">
                                    <svg class="close icon-modal-close" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
                                        <path d="M24,0C10.75,0,0,10.75,0,24s10.75,24,24,24,24-10.75,24-24C47.99,10.75,37.25,0,24,0m8.7,30.07c.73,.73,.73,1.9,0,2.63-.73,.73-1.9,.73-2.63,0h0l-6.07-6.09-6.07,6.09c-.73,.73-1.9,.73-2.63,0-.73-.73-.73-1.9,0-2.63h0l6.09-6.07-6.09-6.07c-.65-.8-.53-1.97,.25-2.63,.69-.58,1.69-.58,2.38,0l6.07,6.09,6.07-6.09c.8-.65,1.97-.53,2.63,.25,.58,.69,.58,1.69,0,2.38l-6.09,6.07,6.09,6.07Z" fill="#ffffff" />
                                    </svg>
                                    <div class="details-container">
                                        <h4>${modal.title}</h4>
                                        <p>${modal.content}</p>
                                        ${this.renderModalButton(modal)}                                
                                    </div>
                                </div>
                            </div>`;
            });

       this.modalsContainer.innerHTML = html;

    };

    renderModalButton(item){

        if(item.linkUrl === null || item.linkUrl === '')
            return '';

        return `<a class="btn btn-sm btn-modal-cta" href="${item.linkUrl}">
                    ${item.linkText}
                </a>`;
    }

    renderCarouselItems(items){

        let html = '';

        items.forEach(item => {

            html+= ` <div class="swiper-slide">
                        <div class="image-container">
                            <picture>
                                <img class="background-image" srcset="${item.imageUrl}" alt="${item.imageAlt}" />
                            </picture>
                            <div class="gradient"></div>
                        </div>
                        ${this.renderModalIcon(item)}                        
                        <div class="details-container">
                            <h3 class="heading">${item.heading}</h3>
                            <h4 class="subheading">${item.subHeading}</h4>
                            ${this.renderPrimaryLink(item)}
                        </div>
                        <div class="spare-background"></div>
                    </div>`;

        });

        this.carouselContainer.innerHTML = html;
    }

    
    renderBlockItems(items){

        let html = '';

        items.forEach(item=> {

            html+=`<div class="item" style="background-image: url('${item.imageUrl}');">
                    <div class="gradient"></div>
                        <div class="spare-background"></div>
                        <div class="hover-details">
                            <div class="hover-details-container">
                                <div class="details-container">
                                    <h3 class="heading">${item.heading}</h3>
                                <h4 class="subheading">${item.subHeading}</h4>
                                    <div class="divider"></div>
                                    <p class="description">${item.description}</p>
                                </div>
                                ${this.renderModalIcon(item)}  
                                ${this.renderPrimaryLink(item)}
                            </div>
                        </div>
                    </div>`

        });

        this.blocksContainer.innerHTML = html;

    }

    renderModalIcon(item){

        if(item.modal === null){
            return '';
        }

        return `<svg class="icon-info" data-modal-open="modal-${item.id}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                    <path d="M16,0C7.16,0,0,7.16,0,16s7.16,16,16,16,16-7.16,16-16C32,7.17,24.83,0,16,0m-.31,7.39c1.02,0,1.85,.83,1.85,1.85s-.83,1.85-1.85,1.85-1.85-.83-1.85-1.85h0c0-1.02,.83-1.84,1.85-1.85m1.54,17.23h-1.23c-.68,0-1.23-.55-1.23-1.23v-7.39c-.68,0-1.23-.55-1.23-1.23s.55-1.23,1.23-1.23h1.23c.68,0,1.23,.55,1.23,1.23v7.38c.68,0,1.23,.55,1.23,1.23s-.55,1.23-1.23,1.23" fill="#fff"/>
                </svg>`;
    }

    renderPrimaryLink(item){

        if(item.primaryLinkUrl === null)
            return '';

        return `<a data-dstapi-click
                    data-dstapi-event="card_interaction"
                    data-dstapi-header="${this.title.innerText}" 
                    data-dstapi-cta_text="${item.primaryLinkText}"
                    data-dstapi-title="${item.heading}"
                    data-dstapi-custom_country="${window.DSTAPI.country}"
                    title="${item.heading}, ${item.primaryLinkText}"
                    aria-label="${item.heading}, ${item.primaryLinkText}"
                    class="btn btn-sm btn-cta" 
                    href="${item.primaryLinkUrl}" 
                    target="_self">
                    ${item.primaryLinkText}
                </a>`;
    }


    initSwiper() {
        this.swiper = new Swiper(this.swiperElem, {
            direction: 'horizontal',
            loop: true,
            slidesPerView: 1.15,
            centeredSlides: true,
            spaceBetween: 15,
            grabCursor: true,
            pagination: {
                el: `.swiper-pagination`,
                clickable: true
            },
            breakpoints: {
                998: {
                    slidesPerView: 3,
                    centeredSlides: false,
                    spaceBetween: 30
                },
                1400: {
                    slidesPerView: 5,
                    centeredSlides: false,
                    spaceBetween: 30
                }
            }
        });

        this.swiper.update();
    }

    setModalEvents() {

        this.modals = this.modalsContainer.querySelectorAll(this.options.modal);   
        
        this.container
            .querySelectorAll(this.options.infoIcon)
            .forEach(icon => {
                icon.addEventListener('click', e => {
                    e.stopPropagation()
                    this.modals.forEach(modal => {
                        if (modal.dataset.modalId === icon.dataset.modalOpen) {
                            modal.classList.add('active')
                        }
                    });           
                });
            });

        this.container
            .querySelectorAll(this.options.modalClose)
            .forEach(icon => {
                icon.addEventListener('click', e => {
                    e.stopPropagation()
                    this.modals.forEach(modal => { 
                        modal.classList.remove('active')
                    })
                })
            });
        
    }
}